import { type Gateway, useGateway } from '@ad-lucy/gateway-provider';
import { getAppConfig } from '@modules/config/appConfig';

type MfPersonalSettingsConfig = {
  API_ROOT: string;
  IMG_URL: string;
  SUPPORTED_LANGUAGES: string;
  THEME_URL: string;
};

type MfPersonalSettingsReturnProps = {
  gateway: Gateway;
  appConfig: MfPersonalSettingsConfig;
};

const useMfPersonalSettingsConfig = (): MfPersonalSettingsReturnProps => {
  const gateway = useGateway();
  const appConfig = getAppConfig();

  return {
    gateway,
    appConfig: {
      API_ROOT: appConfig.API_ROOT,
      IMG_URL: appConfig.IMG_URL,
      SUPPORTED_LANGUAGES: appConfig.SUPPORTED_LANGUAGES,
      THEME_URL: appConfig.THEME_URL,
    },
  };
};

export { useMfPersonalSettingsConfig };
